import React, { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Tooltip } from "antd";
import CommonDeleteModal from "../CommonDelete&ActiveModal/CommonDeleteModal";
import loader from "../../methods/loader";
import Pagination from "react-pagination-js";
import { useSelector } from "react-redux";
import Layout2 from "../../components/global/layout2";

const categoryOptions = [
  { value: "", label: "All Categories" },
  { value: "onboarding", label: "Onboarding" },
  { value: "bid", label: "Bid" },
  { value: "load", label: "Load" },
  { value: "carrier", label: "Carrier" },
  { value: "driver", label: "Driver" },
  { value: "system", label: "System" },
  { value: "custom", label: "Custom" },
];

const statusOptions = [
  { value: "", label: "All Statuses" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "draft", label: "Draft" },
];

const EmailTemplates = () => {
  const [data, setdata] = useState([]);
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [ShowDeleteModal, setShowDeleteModal] = useState("none");
  const [DeleteId, setDeleteId] = useState("");
  const [loaderr, setLoaderr] = useState(false);

  const user = useSelector((state) => state.user);
  const searchState = useSelector((state) => state.search);

  const [filters, setFilter] = useState({
    page: 1,
    count: 20,
    search: "",
    category: "",
    status: "",
  });

  const Delete = () => {
    Deletedata(DeleteId);
  };

  const ChangeFilter = (e) => {
    setFilter(e);
    Getdata(e);
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    Getdata({ page: e });
  };

  const Getdata = (p = {}) => {
    loader(true);
    setLoaderr(true);
    let filter = { ...filters, ...p };
    // Remove empty filter values
    let params = {};
    Object.keys(filter).forEach((key) => {
      if (filter[key] !== "" && filter[key] !== undefined) {
        params[key] = filter[key];
      }
    });
    ApiClient.get("email-templates", params).then((res) => {
      if (res.success) {
        setdata(res?.data?.data || res?.data || []);
        setTotal(res?.data?.total_count || res?.data?.total || 0);
      }
      loader(false);
      setLoaderr(false);
    });
  };

  useEffect(() => {
    Getdata();
  }, []);

  useEffect(() => {
    if (user && user.loggedIn) {
      setFilter({ ...filters, search: searchState.data });
      Getdata({ search: searchState.data, page: 1 });
    }
  }, [searchState]);

  const Deletedata = (id) => {
    loader(true);
    ApiClient.delete(`email-template`, { id: id }).then((res) => {
      if (res.success) {
        toast.success("Template deleted successfully");
        Getdata();
        setShowDeleteModal("none");
      }
      loader(false);
    });
  };

  const handleSearch = (e) => {
    const val = e.target.value;
    setFilter({ ...filters, search: val, page: 1 });
    // Debounce search
    clearTimeout(window._emailSearchTimeout);
    window._emailSearchTimeout = setTimeout(() => {
      Getdata({ search: val, page: 1 });
    }, 400);
  };

  const getStatusBadge = (status) => {
    const colors = {
      active: { bg: "#e6f7ee", color: "#389e6b" },
      inactive: { bg: "#fff1f0", color: "#cf1322" },
      draft: { bg: "#fff7e6", color: "#d48806" },
    };
    const style = colors[status] || colors.draft;
    return (
      <span
        style={{
          padding: "4px 12px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
          backgroundColor: style.bg,
          color: style.color,
          textTransform: "capitalize",
        }}
      >
        {status || "draft"}
      </span>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleSendTest = (item) => {
    const email = prompt("Enter email address to send test:");
    if (!email) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    loader(true);
    ApiClient.post("email-template/send-test", {
      id: item.id || item._id,
      to: email,
      variables: {},
    }).then((res) => {
      if (res.success) {
        toast.success("Test email sent successfully");
      }
      loader(false);
    });
  };

  return (
    <Layout2 title="Email Templates" Sidetitle="Email Templates">
      <div className="mainareas new-table-set">
        <CommonDeleteModal
          show={ShowDeleteModal}
          setShow={setShowDeleteModal}
          confirm={Delete}
        />

        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="bids-top mb-2 mb-sm-0">
            <h4>
              Results<span>{total}</span>
            </h4>
          </div>
          <a
            className="btn btn-primary py-2"
            onClick={() => history.push("/email-templates/add")}
          >
            <i className="fas fa-plus-circle me-2"></i>
            Create New Template
          </a>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-3 mb-3">
          <div style={{ minWidth: "220px", flex: 1, maxWidth: "350px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search templates..."
              value={filters.search}
              onChange={handleSearch}
            />
          </div>
          <div>
            <select
              className="form-control"
              value={filters.category}
              onChange={(e) => {
                const val = e.target.value;
                setFilter({ ...filters, category: val, page: 1 });
                Getdata({ category: val, page: 1 });
              }}
            >
              {categoryOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) => {
                const val = e.target.value;
                setFilter({ ...filters, status: val, page: 1 });
                Getdata({ status: val, page: 1 });
              }}
            >
              {statusOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive table_section new-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Subject</th>
                <th scope="col">Category</th>
                <th scope="col">Status</th>
                <th scope="col">Last Updated</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((itm, index) => (
                <tr key={itm.id || itm._id || index}>
                  <td>
                    <div className="user_detail">
                      <div className="user_name">
                        <h4
                          className="user"
                          title="Edit"
                          onClick={() =>
                            history.push(
                              `/email-templates/edit/${itm.id || itm._id}`
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {itm.name?.length > 40
                            ? itm.name.substr(0, 40) + "..."
                            : itm.name}
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>
                    {itm.subject?.length > 50
                      ? itm.subject.substr(0, 50) + "..."
                      : itm.subject}
                  </td>
                  <td>
                    <span
                      style={{
                        textTransform: "capitalize",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        backgroundColor: "#f0f2f5",
                        color: "#3E549D",
                        fontWeight: 500,
                      }}
                    >
                      {itm.category || "-"}
                    </span>
                  </td>
                  <td>{getStatusBadge(itm.status)}</td>
                  <td>{formatDate(itm.updatedAt || itm.updated_at)}</td>
                  <td>
                    <div className="action_icons">
                      <Tooltip placement="top" title="Edit">
                        <span
                          className="edit_icon pointer"
                          onClick={() =>
                            history.push(
                              `/email-templates/edit/${itm.id || itm._id}`
                            )
                          }
                        >
                          <i className="material-icons pointer edit">edit</i>
                        </span>
                      </Tooltip>
                      <Tooltip placement="top" title="Send Test">
                        <span
                          className="edit_icon pointer"
                          onClick={() => handleSendTest(itm)}
                        >
                          <i className="material-icons pointer">send</i>
                        </span>
                      </Tooltip>
                      <Tooltip placement="top" title="Delete">
                        <span
                          className="edit_icon pointer"
                          onClick={() => {
                            setShowDeleteModal("block");
                            setDeleteId(itm.id || itm._id);
                          }}
                        >
                          <i className="material-icons delete" title="Delete">
                            delete
                          </i>
                        </span>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {total === 0 && !loaderr ? (
          <div className="no-data">
            <img src="assets/img/no-data.png" alt="No data" />
            No Email Templates Found
          </div>
        ) : null}

        {/* Pagination */}
        {total > 0 ? (
          <div className="paginationWrapper gap-0">
            <div className="d-flex align-items-center mb-2 mb-sm-0">
              <div className="me-2 user-name-color">Show</div>
              {total > 0 && (
                <div className="dropdown addDropdown chnagesname">
                  <button
                    className="btn btn-primary dropdown-toggle removeBg"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {filters?.count}
                  </button>
                  <div
                    className="dropdown-menu shadow bg_hover"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {[10, 20, 30, 50].map((n) => (
                      <a
                        key={n}
                        className="dropdown-item"
                        onClick={() =>
                          ChangeFilter({ ...filters, count: n, page: 1 })
                        }
                      >
                        {n}
                      </a>
                    ))}
                  </div>
                </div>
              )}
              <div className="ms-2 user-name-color">
                from {total} Templates
              </div>
            </div>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
          </div>
        ) : null}
      </div>
    </Layout2>
  );
};

export default EmailTemplates;
